import React from 'react';

import { UNSUPPORTED_NODE_TYPE } from './../../pm-converters/consts';
import { RicosContext } from './../../ricos-context/RicosContext';
import type { PluginProps } from './../../ricos-types';
import GenericError from './../../ui-components/Components/GenericError';
import { createRicosNodeExtension } from './../../tiptap-extensions';

export const UnsupportedBlock: React.FC<PluginProps> = () => {
  const { t } = React.useContext(RicosContext);
  return (
    <div contentEditable={false}>
      <GenericError text={t('UnsupportedPlugin_message')} />
    </div>
  );
};

export const unsupportedNode = createRicosNodeExtension<{
  HTMLAttributes: Record<string, unknown>;
}>({
  groups: ['draggable', 'not-overtypable', 'no-trailing-node'],
  type: 'react-node',
  Component: UnsupportedBlock,
  name: UNSUPPORTED_NODE_TYPE,
  createExtensionConfig: () => ({
    name: UNSUPPORTED_NODE_TYPE,
    addAttributes() {
      return {
        originalNode: {},
      };
    },
    group:
      'block layoutCellContent collapsibleListItemTitleContent collapsibleListItemBodyContent tableCellContent listItemFirstChildContent listItemSecondChildContent figureFirstChildContent figureSecondChildContent',
    selectable: true,
    allowGapCursor: false,
  }),
});
